/**
 * THIS FILE CONTAINS CODEGEN OUTPUT.
 * Consider running the script instead of manually modifying.
 * Future executions of the codegen tooling will overwrite any manual changes.
 */
export { default as DesignTokens } from './DesignTokens';
export { default as TestConfig } from './TestConfig';
export { default as SiteId } from './unified-config/SiteId';
export { default as TokenFormat } from './unified-config/TokenFormat';
export { default as Version } from './unified-config/Version';
//# sourceMappingURL=index.js.map